import axios from 'axios';
import { config } from '@/config';

const instance = axios.create({
  baseURL: config.WHMCS_URL,
  headers: {
    brand: config.COUNTRY,
    'Content-Type': 'application/json',
  },
});

const get = ({
  url, headers, signal,
}) => instance.get(url, { headers, signal });

const useDelete = ({
  url, headers, signal,
}) => instance.delete(url, { headers, signal });

const post = ({
  url, headers, data, signal,
}) => instance.post(url, data, { headers, signal });

const put = ({
  url, headers, data, signal,
}) => instance.put(url, data, { headers, signal });

const patch = ({
  url, headers, data, signal,
}) => instance.patch(url, data, { headers, signal });

const whmcs = {
  instance,
  get,
  post,
  put,
  useDelete,
  patch,
};

export default whmcs;
